import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
    const { pathname } = useLocation();

    useEffect(() => {
        // Disable browser scroll restoration
        if ('scrollRestoration' in window.history) {
            window.history.scrollRestoration = 'manual';
        }

        // Function to scroll all possible scroll containers to top
        const scrollToTop = () => {
            // Scroll window
            try {
                window.scrollTo({
                    top: 0,
                    left: 0,
                    behavior: 'instant'
                });
            } catch (e) {
                window.scrollTo(0, 0);
            }

            // Scroll document elements
            if (document.documentElement) {
                document.documentElement.scrollTop = 0;
            }
            if (document.body) {
                document.body.scrollTop = 0;
            }

            // Scroll Framework7 root if it exists
            const framework7Root = document.getElementById('framework7-root');
            if (framework7Root) {
                framework7Root.scrollTop = 0;
            }

            // Scroll App container if it exists
            const appContainer = document.querySelector('.App');
            if (appContainer) {
                appContainer.scrollTop = 0;
            }
        };

        // Immediate scroll
        scrollToTop();

        // Multiple attempts to handle lazy-loaded components
        // Try after requestAnimationFrame (next paint)
        const rafId1 = requestAnimationFrame(() => {
            scrollToTop();
        });

        // Try after a short delay (handles Suspense)
        const timeoutId1 = setTimeout(scrollToTop, 10);

        // Try after a longer delay (handles lazy-loaded components)
        const timeoutId2 = setTimeout(scrollToTop, 100);

        return () => {
            cancelAnimationFrame(rafId1);
            clearTimeout(timeoutId1);
            clearTimeout(timeoutId2);
        };
    }, [pathname]);

    return null;
};

export default ScrollToTop;

